import React from 'react';
import CurrencyFilledCircleIcon from '../components/Icons/CurrencyFilledCircle';
import DiabetesFriendlyIcon from '../components/Icons/DiabetesFriendly';
import GLP1Icon from '../components/Icons/GLP1';
import HighFiberIcon from '../components/Icons/HighFiber';
import HigherProteinIcon from '../components/Icons/HigherProtein';
import HighProteinFiberIcon from '../components/Icons/HighProteinFiber';
import KetoFriendlyIcon from '../components/Icons/KetoFriendly';
import LessThan500CaloriesIcon from '../components/Icons/LessThan500Calories';
import LowCarbIcon from '../components/Icons/LowCarb';
import LowCarbALaCarteIcon from '../components/Icons/LowCarbALaCarte';
import LowNetCarbsIcon from '../components/Icons/LowNetCarbs';
import LowFatIcon from '../components/Icons/LowFat';
import LowestFatIcon from '../components/Icons/LowestFat';
import LowerSodiumIcon from '../components/Icons/LowerSodium';
import MediterraneanIcon from '../components/Icons/Mediterranean';
import PescetarianIcon from '../components/Icons/Pescetarian';
import PaleoIcon from 'src/components/Icons/Paleo';
import PlantBasedIcon from '../components/Icons/PlantBased';
import PerformanceIcon from '../components/Icons/Performance';
import PrePostPartumIcon from '../components/Icons/PrePostPartum';
import PrenatalIcon from '../components/Icons/Prenatal';
import VeganIcon from '../components/Icons/Vegan';
import VegetarianIcon from '../components/Icons/Vegetarian';
import Whole30Icon from '../components/Icons/Whole30';

/**
 * The original plan was to add an `svg` string column to `panacea.tags` and use string replacement in the `DynamicSvgIcon`
 * component to change the `fill` attributes. That proved to be clunky, as not every `fill` attribute should change. It
 * resulted in a few distorted icons.
 *
 * Creating dedicated icon components allows us to set the various `fill` attributes appropriately for each icon. It's a bit
 * more work, but the icons should not change frequently.
 */
export const TAG_ICONS_BY_LOGICAL_ID: Record<
  string,
  React.FC<{
    fill?: string;
    height?: number;
    width?: number;
  }>
> = {
  DiabetesFriendly: DiabetesFriendlyIcon,
  GLP1: GLP1Icon,
  HighFiber: HighFiberIcon,
  HigherProtein: HigherProteinIcon,
  HighProteinFiber: HighProteinFiberIcon,
  Ketofriendly: KetoFriendlyIcon,
  LessThan500Calories: LessThan500CaloriesIcon,
  LowCarbALaCarte: LowCarbALaCarteIcon,
  Lowcarb: LowCarbIcon,
  LowNetCarbs: LowNetCarbsIcon,
  LowFat: LowFatIcon,
  LowestFat: LowestFatIcon,
  LowerSodium: LowerSodiumIcon,
  Mediterranean: MediterraneanIcon,
  Paleo: PaleoIcon,
  Pescatarian: PescetarianIcon,
  Plantbased: PlantBasedIcon,
  Performance: PerformanceIcon,
  PrePostPartum: PrePostPartumIcon,
  Prenatal: PrenatalIcon,
  Under15Dollars: CurrencyFilledCircleIcon,
  Vegan: VeganIcon,
  Vegetarian: VegetarianIcon,
  Whole30: Whole30Icon,
};
